// extracted by mini-css-extract-plugin
export default {"section":"Home_section__Hxb2e","link":"Home_link__KUon9"};